import { Box, Text, Image, Flex } from "@chakra-ui/react";
import React from "react";
import { images } from "../../../assets";
import { DOC_TYPES } from "../../../utils/const";
import { localeStrings } from "../../../utils/i18n";

export default function ThumbnailView({
  Images,
  setImageUrl,
  OnOpen,
  title = "",
}: {
  Images: Array<Object>;
  setImageUrl: any;
  OnOpen: () => void;
  title?: string;
}) {
  // const filetypes = ['excel','pdf','xls','xlxs','doc','heic','csv'];
  const [filesList, setFilesList] = React.useState<any[]>([]);

  React.useEffect(() => {
    if (Images?.length) {
      const imageFiles: any[] = [];
      const docFiles: any[] = [];

      Images.forEach((file: any) => {
        const fileName = file?.fileName || "";
        const ext = fileName.split(".").pop()?.toLowerCase() || "";

        const isDoc = file?.file?.type?.includes("application") || DOC_TYPES.includes(ext);

        if (isDoc) {
          docFiles.push(file);
        } else {
          imageFiles.push(file);
        }
      });

      // Combine — images first, then docs
      setFilesList([...imageFiles, ...docFiles]);
    }
  }, [Images]);
  return (
    <>
      {filesList?.length ? (
        <Box>
          <Text
            ml={title?.length ? 2 : 0}
            mb={title?.length ? -1 : 0}
            color={"brand.grayMedium"}
            fontSize={"var(--tk-fontSizes-md)"}
          >
            {title?.length ? title : localeStrings("COMMON.REFERENCE_DOCUMENTS")}
          </Text>
          <Flex flexWrap="wrap" alignItems={"end"}>
            {filesList.map((image: any, index: number) => {
              let Id = image?.Id ?? image?.id;
              let fileType = image["fileName"]?.split(".");
              fileType = fileType[fileType.length - 1]?.split("?")?.[0];
              if (fileType.includes("csv") && fileType?.length < 40) {
                fileType = "csv";
              }
              if (image?.fileName) {
                fileType = image.fileName.split(".")?.[1];
              }
              let isImage =
                image?.file?.type.includes("application") || DOC_TYPES.includes(fileType)
                  ? false
                  : true;
              let hasSasURL = !!image?.fileSasTokenUrl?.length;

              return (
                <Box
                  key={Id}
                  position="relative"
                  width={isImage ? 130 : 67}
                  height={isImage ? 130 : 67}
                  display="flex"
                  alignItems="center"
                  justifyContent={"center"}
                  textAlign="center"
                  p="2"
                  m="2"
                  border="1px solid #D9DEE8"
                  borderRadius="8px"
                >
                  {image?.file?.type.includes("application") || DOC_TYPES.includes(fileType) ? (
                    <a href={hasSasURL ? image["fileSasTokenUrl"] : image["sasUrl"]} download>
                      <Image
                        src={
                          fileType === "pdf"
                            ? images.create8D.pdf
                            : fileType === "heic"
                            ? images.create8D.heic
                            : fileType === "doc"
                            ? images.create8D.doc
                            : fileType === "xls" || fileType === "xlsx" || fileType === "excel"
                            ? images.create8D.excel
                            : images.create8D.doc
                        }
                        alt=""
                        width="100%"
                        height={"100%"}
                      />
                    </a>
                  ) : (
                    <Image
                      onClick={() => {
                        setImageUrl(hasSasURL ? image["fileSasTokenUrl"] : image["sasUrl"]);
                        OnOpen();
                      }}
                      src={hasSasURL ? image["fileSasTokenUrl"] : image["sasUrl"]}
                      alt=""
                      width="100%"
                      height={"100%"}
                    />
                  )}
                </Box>
              );
            })}
          </Flex>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
}
